import React from 'react';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseChart } from '@app/components/common/charts/BaseChart';

interface FirmDocumentExpiryCard {
  // eslint-disable-next-line
  EdeData: any;
}
// eslint-disable-next-line
export const FirmDocumentExpiryCard: React.FC<FirmDocumentExpiryCard> = ({ EdeData }) => {
  // Convert object to array of key-value pairs
  const entries = Object.entries(EdeData || {});

  // Sort the array by value in ascending order
  // eslint-disable-next-line
  entries.sort((a: any, b: any) => a[1] - b[1]);

  // Reconstruct the object in sorted order
  const sortedData = Object.fromEntries(entries);

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    grid: {
      top: 50,
      bottom: 20,
    },
    xAxis: {
      type: 'value',
      position: 'top',
      splitLine: {
        lineStyle: {
          type: 'dashed',
        },
      },
    },
    yAxis: {
      type: 'category',
      axisLine: { show: false },
      axisLabel: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      data: Object.keys(sortedData),
    },
    series: [
      {
        name: 'Expiry Days',
        type: 'bar',
        stack: 'Total',
        label: {
          show: true,
          formatter: '{b}',
        },
        data: Object.entries(sortedData)
          // eslint-disable-next-line
          .map(([key, value]) => ({ value }))
          // eslint-disable-next-line
          .map((obj: any) => {
            if (Number(obj.value) < 0) {
              obj.itemStyle = { color: 'rgba(218, 15, 15, 1)' };
            }
            return obj;
          }),
      },
    ],
  };
  return (
    <BaseCard title={'Firm Document Expiry'} padding={'0 1.25rem 1.875rem'}>
      <BaseChart option={option} height="600px"></BaseChart>
    </BaseCard>
  );
};
